import './styles.scss';

import { Box } from '@wix/design-system';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useSearchParams } from 'react-router-dom';

import { Page, useCurrentPage } from '../common/hooks/useCurrentPage';
import { selectArticleHeadingVisible } from '../common/selectors/helpCenter';
import { homepageService } from '../common/services/homepage/homepageService';
import { RouterProvider } from '../react-router';
import { isSmartphone } from '../util';
import {
  biHelpCenter,
  locationToSolutionInfo,
  PresentedState,
} from '../util/bi';
import { emitter } from '../util/emitter';
import { HelpCenterBreadcrumbs } from './components/Breadcrumbs/Breadcrumbs';
import { ChatbotSlider } from './components/ChatbotSlider';
import { Header } from './components/Header';
import { MobileLandscape } from './components/MobileLandscape';
import { SearchBar } from './components/SearchBar';

export const HelpCenterWidget: React.FC = () => {
  const articleHeadingVisible = useSelector(selectArticleHeadingVisible);
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const currentPage = useCurrentPage();
  const headingVisible =
    homepageService.homepageEnabled && !articleHeadingVisible;
  const isChatbotView = homepageService.homepageEnabled
    ? currentPage === Page.Chatbot
    : searchParams.get('isChatbotOpen') !== 'false';

  useEffect(() => {
    const onWidgetExpanded = (widgetExpanded) => {
      if (widgetExpanded && !isChatbotView && currentPage !== Page.Home) {
        const { pathname, search } = location;
        const solution = locationToSolutionInfo(
          pathname,
          search,
          biHelpCenter.searchArticlesList!,
        );
        biHelpCenter.logPresentedContent(solution, PresentedState.WidgetButton);
      }
    };

    emitter.on('widgetExpanded', onWidgetExpanded);
    return () => emitter.removeListener('widgetExpanded', onWidgetExpanded);
  }, [isChatbotView, location]);

  return (
    <>
      <Header />
      {headingVisible && (
        <>
          <SearchBar />
          <HelpCenterBreadcrumbs />
        </>
      )}
      <Box
        position="relative"
        direction="vertical"
        overflow="hidden"
        align="center"
        flexGrow={1}
      >
        {!homepageService.homepageEnabled && <SearchBar />}
        <RouterProvider />
        {!homepageService.homepageEnabled && <ChatbotSlider />}
      </Box>
      {isSmartphone && <MobileLandscape />}
    </>
  );
};
